<template>
    <div class="paperpile_section_wrp">
        <div class="paperpile_content_wrp">
            <div class="paperpile_content_header">
                <div class="row align-items-center">
                    <div class="col">
                        <h2 class="rfiles_main_heading" v-if="bucketDetails"><button type="button" class="btn back_btn"
                                @click="backArrow">
                                <i class="fa fa-chevron-left" aria-hidden="true"></i>
                            </button>{{ bucketDetails.name }}</h2>
                    </div>
                </div>
            </div>
            <div class="paperpile_content_list_wrp mt-4">
                <div class="paperpile_content_list_section" v-if="bucketDetails">
                    <ul class="paperpile_content_list_inner" v-if="bucketDetails.sub_folders.length > 0">
                        <li v-for="(items, index) in visiblePapers" :key="items.id">
                            <div class="row align-items-center">
                                <div class="col-auto pr-0"><span class="paper_number">{{ index + 1 }}.</span></div>
                                <div class="col">
                                    <div class="rfiles_list_title">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <h3>{{ items.pdf_paper.title }}</h3>
                                            </div>
                                            <div class="col-auto ml-auto">
                                                <div class="paper_for_fav_wrp">
                                                    <template v-if="items.pdf_paper.is_favourite">
                                                        <i class="fa fa-star" aria-hidden="true"
                                                            v-on:click="favOfPaperMethod(items.pdf_paper.is_favourite, items.pdf_paper.id)"></i>
                                                    </template>
                                                    <template v-else>
                                                        <i class="fa fa-star-o" aria-hidden="true"
                                                            v-on:click="favOfPaperMethod(items.pdf_paper.is_favourite, items.pdf_paper.id)"></i>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="rfiles_list_action">
                                        <div class="row align-items-center">
                                            <div class="col">
                                                <ul class="rfiles_action_list_wrp">
                                                    <li
                                                        @click="pdfViewerFun(items.pdf_paper.file, items.pdf_paper.file_name, items.pdf_paper.id)">
                                                        Open</li>
                                                    <!-- <li @click="updatePpDetailMethod(items)">Edit</li> -->
                                                    <template v-if="selfUserInfo">
                                                        <li v-on:click="paperSharedMethod(items)"
                                                            v-if="selfUserInfo.pro_payment || selfUserInfo.auto_payment">
                                                            Share</li>
                                                    </template>
                                                    <li @click="noteViewShowMethod(items.pdf_paper)"
                                                        v-if="items.pdf_paper.notes.length > 0">My Notes</li>
                                                    <li @click="paperMoverToFolderMethod(items)">Move</li>
                                                </ul>
                                            </div>
                                            <div class="col-auto">
                                                <i class="fa fa-trash paper_trash_btn" aria-hidden="true"
                                                    @click="trashPaperMethod(items.pdf_paper.id)"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                    <div class="no_have_papers_text" v-else>Your library is empty. Start building your research
                        collection.</div>
                </div>
            </div>
        </div>
        <!-- Pdf VIewer Popup -->
        <pdf-viewer v-if="pdfViewerPopup" v-bind:pdfViewerURL="pdfViewerUrl"
            v-bind:pdfViewerFileNAME="pdfViewerFileName" :pdfID="pdfId"></pdf-viewer>
        <!-- Update PP Details -->
        <update-pp-details v-if="updatePaperPileDetailPopupState"
            :paperUpdateINFO="paperUpdateInfo"></update-pp-details>
        <paper-move-to-folder v-if="paperMoverToFolder"
            :paperMoverToFolderDATA="paperMoverToFolderData"></paper-move-to-folder>
        <note-read-view :notesViewDATA="notesViewData" v-if="notesViewPopupState"></note-read-view>
        <trash-paper-popup v-if="trashPaperState" :trashPaperID="trashPaperId"></trash-paper-popup>
        <paper-share v-if="sharedPaperState" :sharedPaperINFO="sharedPaperInfo"></paper-share>
    </div>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
    bus
} from '@/main';
import {
    mapGetters,
} from 'vuex';
import noteReadView from '../paper-note-read-view';
import paperMoveToFolder from '../paper-move-to-folder';
import paperSharedToUser from '../paper-share-with-user-popup';
import pdfViewer from '../pdf-viewer';
import ppLeftSidebar from '../paperpile-left-sidebar';
import toast from '@/services/toast';
import trashPaperPopup from '../trash-paper-popup';
import updatePpDetails from '../update-paperpile-details';

export default {
    name: 'bucket-details',
    components: {
        'pp-left-sidebar': ppLeftSidebar,
        'pdf-viewer': pdfViewer,
        'update-pp-details': updatePpDetails,
        'paper-move-to-folder': paperMoveToFolder,
        'note-read-view': noteReadView,
        'paper-share': paperSharedToUser,
        'trash-paper-popup': trashPaperPopup,
    },
    props: ['bucketId'],
    data() {
        return {
            bucketDetails: null,
            checkBucketId: '',
            userLoading: false,
            pdf_is_fav: Boolean,
            pdfViewerPopup: false,
            pdfViewerUrl: '',
            pdfViewerFileName: '',
            updatePaperPileDetailPopupState: false,
            pdfId: '',
            paperMoverToFolder: false,
            paperMoverToFolderData: null,
            notesViewData: null,
            notesViewPopupState: false,
            paperUpdateInfo: null,
            sharedPaperState: false,
            sharedPaperInfo: null,
            trashPaperState: false,
            trashPaperId: '',
            selfUserInfo: null
        }
    },
    computed: {
        ...mapGetters([
            'getBucketDetailByIdOfAwerackGetters',
            'acUserDetailsStateGetters'
        ]),
        getSelfUserDetailsFun() {
            this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data
            return
        },
        getBucketDetailsFun() {
            this.bucketDetails = this.$store.getters.getBucketDetailByIdOfAwerackGetters.data;
            return
        },
        visiblePapers() {
            if (!this.bucketDetails || !Array.isArray(this.bucketDetails.sub_folders)) {
                return []
            }
            return this.bucketDetails.sub_folders.filter(item => !item.is_folder)
        },
    },
    mounted() {
        this.getSelfUserDetailsFun
        this.getBucketDetailsFun
        bus.$on('pdfViewerPopupBus', (data) => {
            this.pdfViewerPopup = data;
        });
        bus.$on('updatePaperPileDetailPopupStateBus', (data) => {
            this.updatePaperPileDetailPopupState = data;
        });
        bus.$on('paperMoverToFolderBus', (data) => {
            this.paperMoverToFolder = data;
        });
        bus.$on('notesViewPopupStateBus', (data) => {
            this.notesViewPopupState = data;
        });
        bus.$on('trashPaperStateBus', (data) => {
            this.trashPaperState = data;
        });
        bus.$on('sharedPaperBus', (data) => {
            this.sharedPaperState = data;
        });
    },
    methods: {
        paperSharedMethod(data) {
            this.sharedPaperInfo = data.pdf_paper
            this.sharedPaperState = true
            $('body').addClass('body_right_scroll_remove')
        },
        trashPaperMethod(ID) {
            this.trashPaperId = ID
            this.trashPaperState = true
            $('body').addClass('body_right_scroll_remove')
        },
        noteViewShowMethod(data) {
            this.notesViewData = data
            this.notesViewPopupState = true
            $('body').addClass('body_right_scroll_remove')
        },
        paperMoverToFolderMethod(data) {
            this.paperMoverToFolderData = data.pdf_paper
            this.paperMoverToFolder = true
            $('body').addClass('body_right_scroll_remove')
        },
        backArrow() {
            return this.$router.go(-1)
        },
        pdfViewerFun(url, fileName, id) {
            this.pdfId = id
            this.pdfViewerFileName = fileName
            this.pdfViewerUrl = url
            this.pdfViewerPopup = true
            $('body').addClass("pdf_view_actv")
        },
        openPopupOfAddPaperPile() {
            this.addPaperPilePopupState = true
            $('body').addClass('body_right_scroll_remove')
        },
        updatePpDetailMethod(data) {
            this.paperUpdateInfo = data.pdf_paper
            this.updatePaperPileDetailPopupState = true
            $('body').addClass('body_right_scroll_remove')
        },
        favOfPaperMethod(isFav, paperId) {
            if (isFav == true) {
                this.pdf_is_fav = false
            } else {
                this.pdf_is_fav = true
            }
            let data = {
                is_favourite: this.pdf_is_fav
            }
            this.$store.dispatch('updatePaperPileDetailsByIdFun', { data: { id: paperId, data: data } })
                .then((res) => {
                    toast.success(res.data.msg);
                    this.getPaperPileInfoAgain()
                }).catch((err) => {
                    toast.error(err.data.user_msg || err.data.msg);
                })
        },
        getPaperPileInfoAgain() {
            this.$store.dispatch('getBucketDetailsByIdOfAwerackFun', { id: this.bucketId }).then((res) => {
            }).catch((err) => {
            })
        }
    },
    watch: {
        getSelfUserDetailsFun() {
            return this.$store.getters.acUserDetailsStateGetters
        },
        getBucketDetailsFun() {
            return this.$store.getters.getBucketDetailByIdOfAwerackGetters
        },
        bucketId(new_val, old_val) {
            this.$store.dispatch('getBucketDetailsByIdOfAwerackFun', { id: new_val }).then((res) => {
            }).catch((err) => {
            })
        }
    },
    beforeCreate: function () {
        $('body').addClass('researchfile_body_wrp')
    },
    beforeRouteLeave: function (to, from, next) {
        if (to.name != 'awerackResearchGroup' && to.name != 'paperPilesPreferences') {
            $('body').removeClass('researchfile_body_wrp');
        }
        next();
    },
}
</script>

<style lang="scss" scoped>
.paperpile_section_wrp {
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    height: 100%;

    a {
        text-decoration: none;
    }

    &>.row {
        min-height: calc(100dvh - 80px);
    }
    .paperpile_content_header {
        padding: 0px 15px 20px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        margin: 0 -15px;

        .rfiles_main_heading {
            color: #ffffff;
            font-size: 24px;
            text-transform: uppercase;
            font-weight: bold;
            margin: 0px;
        }

        .rfiles_main_subheading {
            margin: 2px 0px 0px;
            font-size: 18px;
            color: #ffd700;
            line-height: 1;
        }

        .rfiles_searchbar {
            position: relative;

            .fa {
                font-size: 18px;
                cursor: pointer;
                color: #c0c0c0;
                position: absolute;
                top: 10px;
                left: 10px;
            }

            &:focus-within {
                .fa {
                    color: #ffd700;
                }
            }

            .form-control {
                background: linear-gradient(-30deg, rgba(37, 44, 84, 0.6) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(38, 38, 38, 0.6) 50%, rgba(44, 44, 84, 0.6) 100%);
                box-shadow: -5px 5px 10px rgba(82, 106, 133, 0.06);
                font-size: 18px;
                color: #ffd700;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                border: 1px solid rgba(93, 93, 93, 0.5);
                height: auto;
                width: 280px;
                line-height: 38px;
                padding: 0px 15px 0 40px;
                -webkit-box-shadow: none;
                box-shadow: none;

                &:hover {
                    border-color: #ffd700;
                }

                &:focus {
                    border-color: #ffd700;
                }

                @media only screen and (max-width:769px) {
                    width: 100%;
                }

                &::-moz-placeholder {
                    color: #dfdfdf;
                }

                &::-webkit-input-placeholder {
                    color: #dfdfdf;
                }

                &:focus::-webkit-input-placeholder {
                    font-size: 0px;
                }

                &:focus::-moz-placeholder {
                    font-size: 0px;
                }
            }
        }

        .rfiles_header_right_side {
            display: flex;
            align-items: center;
            margin-bottom: 0px;

            li {
                margin-right: 10px;

                &:last-child {
                    margin-right: 0px;
                }
            }

            .btn-primary {
                cursor: pointer;
                position: relative;
                min-width: 95px;
                -webkit-box-shadow: none !important;
                box-shadow: none !important;
                outline: none !important;
                background: #b41818;
                color: #ffffff;
                border: none;
                border-radius: 3px;
                font-family: 'MyriadProRegular', 'Lato', sans-serif;
                font-size: 18px;
                letter-spacing: 0.5px;

                @media only screen and (max-width:769px) {
                    font-size: 16px;
                    padding: 6px;
                }

                &:hover {
                    background: #87cefa;
                    color: #22292f;
                }
            }
        }
    }

    .paperpile_content_wrp {
        background: rgba(9, 9, 9, 0.95);
        -webkit-box-shadow: -3px 1px 10px rgba(138, 145, 153, 0.05);
        box-shadow: -3px 1px 10px rgba(138, 145, 153, 0.05);
        border-radius: 5px;
        padding: 15px;
        height: 100%;

        @media only screen and (max-width:769px) {
            min-height: calc(100dvh - 90px);
        }
    }

    .paperpile_content_list_inner {
        margin: 0px;

        &>li {
            background: linear-gradient(-30deg, rgba(37, 44, 84, 0.98), rgba(0, 0, 0, 0.98) 50%, rgba(38, 38, 38, 0.98) 0, rgba(44, 44, 84, 0.98));
            padding: 25px;
            border-radius: 20px;
            margin-bottom: 10px;
            border: 1px solid rgba(93, 93, 93, 0.5);

            .rfiles_list_title {
                margin-bottom: 0px;

                h3 {
                    font-size: 22px;
                    color: #ffffff;
                    margin-bottom: 0px;
                    line-height: 1.2;
                }
            }

            .files_directory_path {
                margin-top: 5px;

                h3 {
                    font-size: 14px;
                    color: #878787;
                    margin: 0;
                    line-height: 1;
                    font-weight: normal;
                    font-family: 'MyriadProRegular', 'Lato', sans-serif;
                }
            }

            .rfiles_list_action {
                border-top: 1px solid rgba(255, 255, 255, 0.05);
                padding-top: 20px;
                position: relative;
                margin-top: 20px;
            }

            .rfiles_action_list_wrp {
                display: flex;
                align-items: center;

                li {
                    margin-right: 15px;
                    font-size: 16px;
                    color: #ffe9e9;
                    cursor: pointer;
                    border: 1px solid #ffe9e9;
                    padding: 0 20px;
                    line-height: 30px;
                    border-radius: 30px;

                    &:hover {
                        background: #ffe9e9;
                        color: #000000;
                    }

                    @media only screen and (max-width:767px) {
                        & {
                            margin-right: 10px;

                            &:last-child {
                                margin-right: 0px;
                            }
                        }
                    }
                }
            }

            .paper_for_fav_wrp {
                .fa {
                    font-size: 22px;
                    color: #fff8d8;
                    cursor: pointer;
                    line-height: 1.3;

                    &:hover {
                        color: #87cefa;
                    }
                }
            }

            .paper_number {
                font-size: 18px;
                color: #fff8d8;
            }
        }
    }

    .load_more_btn {
        color: #fff !important;
        background: rgba(255, 255, 255, 0.1);
        padding: 5px;
        min-width: 110px;
        font-size: 16px;
        border-radius: 3px;
        border: 0 !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        margin: 15px 0;

        &:hover {
            color: #000 !important;
            background: #87cefa;
        }
    }

    .fixloader {
        align-items: flex-end;
    }

    .load_more_li_wrp {
        text-align: center;
    }

    .no_have_papers_text {
        text-align: center;
        font-family: 'MyriadProRegular', 'Lato', sans-serif;
        font-size: 18px;
        color: #ffffff;
        background: rgba(255, 255, 255, 0.08);
        padding: 50px 15px;
        border-radius: 5px;
        margin-bottom: 10px;
    }

    .paper_trash_btn {
        font-size: 20px;
        cursor: pointer;
        color: #fff8d8;

        &:hover {
            color: #87cefa;
        }
    }
}
</style>